import { QTD_DEPENDENTES_ENUM } from '../../helpers/funcoesPadroes';
import {
    IDADE_ENUM,
    validarCategoria,
    validarExisteDoisDependAcima65Anos,
    validarLimiteCategoria,
    retornaLabelDoValorParentesco,
    validatorParentescoEmDuplicidade,
    validatorDependenteSemValorAdicional,
    comparaRegrasDepAtuaisComDepUpSell
} from '../zsCidadesSelecionadas/funcoesAuxiliaresZSCidades';

export class CorrenteCadastroZSCidades {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        idadeAssociado,
        troca,
        subGrupoSelecionadoUpSell
    ) {
        if (subGrupoSelecionadoUpSell) {
            this.dependentes = dependentes.filter(dependente => dependente.Status === true);
        } else {
            this.dependentes = dependentes;
        }

        this.parentesco = parentesco;
        this.categorias = categorias;
        this.valoresForm = valoresForm;
        this.idadeAssociado = idadeAssociado;
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;
        this.troca = subGrupoSelecionadoUpSell ? true : troca;
        this.arrayMsgsErro = [];
        this.categoriaSelecionada = valoresForm.Categoria;
        this.dependentesInseridos = this.dependentes.length;
        this.maximoDependentes = this.troca ?
            QTD_DEPENDENTES_ENUM.nove :
            QTD_DEPENDENTES_ENUM.sete;
        this.temDependenteEspecial = this.dependentes.some(dep => (dep.Categoria || dep['CategoriaParentesco.Categoria']) !== 'ZELO');
        this.limiteDependente = !this.temDependenteEspecial ?
            this.maximoDependentes :
            this.maximoDependentes + 1;
    }

    validarRegrasDepAtuaisComDepUpSell() {
        if (this.subGrupoSelecionadoUpSell) {
            const comparacaoDepAtualDepUpSell = comparaRegrasDepAtuaisComDepUpSell(this.dependentes);

            if (comparacaoDepAtualDepUpSell) {
                this.arrayMsgsErro = [
                    ...this.arrayMsgsErro,
                    comparacaoDepAtualDepUpSell
                ];
            }
        }

        return this;
    }

    validaSequenciaDependentes() {
        if (this.dependentesInseridos < this.limiteDependente) {
            if (!['', 'ZELO'].includes(this.valoresForm.Categoria)) {
                const msgErro = `Você precisa adicionar ${this.maximoDependentes} dependentes sem valor adicional antes de adicionar dependente especial.`;

                this.arrayMsgsErro.push(
                    msgErro
                );
            }
        } else {
            if (this.dependentesInseridos >= QTD_DEPENDENTES_ENUM.nove && this.valoresForm.Categoria === 'ZELO') {
                this.arrayMsgsErro.push(
                    `Ao exceder ${this.limiteDependente} dependentes deverá ser cobrado o valor adicional.`
                );
            }
        }

        return this;
    }

    verificarQuantidadeDependentes() {
        if (
            this.dependentesInseridos >= this.maximoDependentes &&
            !this.temDependenteEspecial
        ) {
            if (this.valoresForm.Categoria.trim() === 'ZELO') {
                this.arrayMsgsErro.push(
                    'Ainda pode ser inserido um dependente especial.'
                );
            }
        }

        if (
            this.subGrupoSelecionadoUpSell &&
            this.dependentesInseridos > this.limiteDependente
        ) {
            const msgErro =
                `O número de dependentes já cadastrados excede o limite permitido pelo seu novo plano. 
                    Por favor, ajuste o número para ${this.limiteDependente} dependentes  para prosseguir.`;

            this.arrayMsgsErro.push(msgErro);
        } else if (
            this.dependentesInseridos >= this.limiteDependente &&
            this.temDependenteEspecial &&
            this.valoresForm.Nome !== ''
        ) {
            const msgErro = `O máximo de ${this.limiteDependente} dependentes foi cadastrado.`;

            this.arrayMsgsErro.push(msgErro);
        }

        return this;
    }

    verificarIdadeDependentes() {
        if (this.categoriaSelecionada) {
            if (
                (this.valoresForm.Idade >= IDADE_ENUM.sessentaCinco &&
                    this.valoresForm.Categoria.trim() === 'ZSA64') ||
                (this.valoresForm.Idade < IDADE_ENUM.sessentaCinco &&
                    this.valoresForm.Categoria.trim() === 'ZSM65')
            ) {
                this.arrayMsgsErro.push(
                    'A Categoria selecionada não está de acordo com a idade do dependente.'
                );
            }
        }

        return this;
    }

    validarCategoriasPlano() {
        switch (this.valoresForm.Categoria.trim()) {
            case 'ZELO':
                if (
                    !validarLimiteCategoria(
                        this.dependentes,
                        'ZELO',
                        this.maximoDependentes
                    )
                ) {
                    this.arrayMsgsErro.push(
                        `O máximo de dependentes sem valor adicional são ${this.maximoDependentes} dependentes.`
                    );
                }

                break;
            case 'ZSA64':
                if (
                    !validarLimiteCategoria(
                        this.dependentes,
                        'ZSA64',
                        QTD_DEPENDENTES_ENUM.um
                    )
                ) {
                    this.arrayMsgsErro.push(
                        'O máximo de dependentes pela categoria ZELO SUPREMO ATÉ 64 ANOS é um dependente.'
                    );
                }

                break;
            case 'ZSM65':
                if (
                    !validarLimiteCategoria(
                        this.dependentes,
                        'ZSM65',
                        QTD_DEPENDENTES_ENUM.um
                    )
                ) {
                    this.arrayMsgsErro.push(
                        'O máximo de dependentes pela categoria ZELO SUPREMO MAIS DE 65 ANOS é um dependente.'
                    );
                }

                break;
        }

        if (this.valoresForm.Categoria && this.valoresForm.Categoria !== 'ZELO') {
            if (!validarCategoria(this.dependentes, this.valoresForm.Categoria)) {
                this.arrayMsgsErro.push(
                    'Para este plano só pode ser inserido um dependente especial.'
                );
            }
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    validarQtdDependentesAcima65Anos() {
        if (
            validarExisteDoisDependAcima65Anos(
                this.dependentes,
                this.valoresForm.Idade,
                this.idadeAssociado
            )
        ) {
            this.arrayMsgsErro.push(
                'Neste plano só é permitido duas pessoas acima de 64 anos, incluindo o titular.'
            );
        }

        return this;
    }

    parentescosSemValorAdicional() {
        if (validatorDependenteSemValorAdicional(this.valoresForm)) {
            this.arrayMsgsErro.push(
                'Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.'
            );
        }

        return this;
    }
}
